<template>
  <div class="st-tooltip" role="tooltip" @keydown="keyDown" aria-live="polite">
    <div
      class="tooltiptext"
      v-if="showContent"
      @mousedown="toggleContent"
      tabindex="0"
      ref="content"
    >
      <slot>
        Tooltip Content
      </slot>
    </div>
    <component
      :is="icon"
      :size="size"
      :name="iconName"
      :alt="alt"
      :click="toggleContent"
      tabindex="0"
      :classes="filled ? ['filled'] : []"
    />
  </div>
</template>

<script>
import StIcon from "../icon/Icon";
import StIconLegacy from "../icon/IconLegacy.vue";

import { version } from "vue";
export default {
  components: {
    StIcon,
    StIconLegacy,
  },
  props: {
    iconName: {
      type: String,
      required: false,
      default: "info",
    },
    size: {
      type: String,
      required: false,
      default: "sm",
    },
    filled: {
      type: Boolean,
      default: true,
    },
    alt: {
      type: String,
      required: false,
      default: "öppna informationsruta",
    },
  },
  computed: {
    icon() {
      return version && parseInt(version) === 3 ? "StIcon" : "StIconLegacy";
    },
  },
  data() {
    return {
      showContent: false,
    };
  },
  methods: {
    toggleContent() {
      this.showContent = !this.showContent;

      if (this.showContent) this.validatePosition();
    },
    validatePosition() {
      var screenSize = window.innerWidth;
      this.$nextTick(function() {
        let elementData = this.$refs.content.getBoundingClientRect();
        var overlap = elementData.right - screenSize;
        if (elementData.left < 0) {
          this.$refs.content.style.left = "10";
          this.$refs.content.style.right = "auto";
          this.$refs.content.style.transform = `translateX(${-elementData.x +
            10}px)`;
        } else if (elementData.right > screenSize) {
          this.$refs.content.style.left = "auto";
          this.$refs.content.style.right = (screenSize - 20).toString;
          this.$refs.content.style.transform = `translateX(${-overlap - 20}px)`;
        }
      });
    },
    keyDown(e) {
      switch (e.keyCode) {
        case 27:
          this.toggleContent();
          break;
        case 13:
          this.toggleContent();
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";

.st-tooltip {
  position: relative;
  display: inline-flex;
  opacity: 1;

  .st-icon {
    font-size: rem-calc(16);
    margin-left: $xs;
  }

  .filled {
    background-color: $bg-grey;
  }

  .tooltiptext {
    width: rem-calc(310);
    bottom: 100%;
    left: 50%;
    margin-left: rem-calc(
      -155
    ); /* Use half of the width (310/2 = 155), to center the tooltip */
    border-radius: rem-calc(4);
    background-color: $bg-grey;
    font-size: rem-calc(14);
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.36;
    letter-spacing: normal;
    color: $grey-dark;
    padding: rem-calc(13) rem-calc(16);
    border: $border-width--thin solid rgba(110, 96, 84, 0.2);
    word-wrap: break-word;
    position: absolute;
    z-index: 1;
  }
}
</style>